import { render, staticRenderFns } from "./NewsDashboardItem.vue?vue&type=template&id=41a0ca1d"
import script from "./NewsDashboardItem.vue?vue&type=script&lang=js"
export * from "./NewsDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./NewsDashboardItem.vue?vue&type=style&index=0&id=41a0ca1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressCircular,VTimeline,VTimelineItem})
